import { useState } from 'react';
import type { TextareaAutosizeProps } from 'react-textarea-autosize';
import ReactTextareaAutosize from 'react-textarea-autosize';

// -- Hooks --
import { useIsomorphicLayoutEffect } from 'containers/Tiptap/hooks/use-isomorphic-layout-effect';

export function TextareaAutosize({ ...props }: TextareaAutosizeProps): React.ReactElement | null {
  const [isRerendered, setIsRerendered] = useState(false);

  useIsomorphicLayoutEffect(() => setIsRerendered(true), []);

  return isRerendered ? <ReactTextareaAutosize {...props} /> : null;
}

TextareaAutosize.displayName = 'TextareaAutosize';
